import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BarChart3, 
  FileText, 
  Wrench, 
  Car, 
  TrendingUp,
  Calendar,
  DollarSign,
  Lock
} from 'lucide-react';

const reportCards = [
  {
    title: 'Relatórios Financeiros',
    description: 'Análise completa de receitas e despesas',
    icon: BarChart3,
    bgColor: 'bg-blue-50',
    iconBg: 'bg-blue-500',
    iconColor: 'text-white',
    link: '/relatorios/financeiros'
  },
  {
    title: 'Histórico de Fechamentos',
    description: 'Visualize fechamentos mensais e tendências',
    icon: Lock,
    bgColor: 'bg-indigo-50',
    iconBg: 'bg-indigo-500',
    iconColor: 'text-white',
    link: '/relatorios/fechamentos'
  },
  {
    title: 'Relatório de Contratos',
    description: 'Visualize todos os contratos e seus status',
    icon: FileText,
    bgColor: 'bg-purple-50',
    iconBg: 'bg-purple-500',
    iconColor: 'text-white',
    link: '/relatorios/contratos'
  },
  {
    title: 'Relatório de Manutenções',
    description: 'Histórico completo de manutenções',
    icon: Wrench,
    bgColor: 'bg-orange-50',
    iconBg: 'bg-orange-500',
    iconColor: 'text-white',
    link: '/relatorios/manutencoes'
  },
  {
    title: 'Relatório Semanal',
    description: 'Resumo semanal de operações',
    icon: Calendar,
    bgColor: 'bg-teal-50',
    iconBg: 'bg-teal-500',
    iconColor: 'text-white',
    link: '/relatorios/semanal'
  },
  {
    title: 'Relatório de Veículos',
    description: 'Listagem completa da frota',
    icon: Car,
    bgColor: 'bg-blue-50',
    iconBg: 'bg-blue-400',
    iconColor: 'text-white',
    link: '/relatorios/veiculos'
  },
  {
    title: 'Rentabilidade de Veículos',
    description: 'Análise de lucro e prejuízo por veículo',
    icon: DollarSign,
    bgColor: 'bg-green-50',
    iconBg: 'bg-green-500',
    iconColor: 'text-white',
    link: '/relatorios/rentabilidade'
  }
];

export default function ReportsMenuPage() {
  return (
    <div className="space-y-6" data-testid="reports-menu-page">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-purple-600 font-[Manrope]">Relatórios</h1>
        <p className="text-gray-500 mt-1">Escolha um relatório para visualizar</p>
      </div>

      {/* Report Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reportCards.map((card, index) => {
          const Icon = card.icon;
          return (
            <Link
              key={index}
              to={card.link}
              className={`${card.bgColor} rounded-2xl p-6 hover:shadow-lg transition-all duration-300 border border-gray-100 group`}
              data-testid={`report-card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className={`${card.iconBg} w-14 h-14 rounded-xl flex items-center justify-center mb-4 shadow-md`}>
                <Icon className={`w-7 h-7 ${card.iconColor}`} />
              </div>
              
              <h3 className="text-lg font-bold text-gray-800 mb-1">
                {card.title}
              </h3>
              
              <p className="text-gray-500 text-sm mb-4">
                {card.description}
              </p>
              
              <span className="text-purple-600 font-medium text-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Acessar
                <span className="text-lg">→</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
